<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <h1>Document Details</h1>
            <ol class="breadcrumb" id="breadcrumbNav" style="margin-bottom:10px;padding:0px 15px;">
                <li>
                    <a [routerLink]="['/home']">
                        <i class="fa fa-home "></i>
                        <span>ProManual </span>
                    </a>
                </li>
                <li class="active">
                    <i class="fa fa-list"></i>
                    <span>Document Details </span>
                </li>
            </ol>
        </div>
    </div>
</div>
<div class="component-container heightcls">
    <div class="well" style="height: 90%;overflow:auto;">
        <document-list></document-list>
    </div>
</div>